import { Component } from '@angular/core';
import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';
import { Router, ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { NbToastrService, NbProgressBarModule } from '@nebular/theme';

import { GoalData } from '../../../../@core/interfaces/common/CalorieFriend/goals';

import { NgxFilterByNumberComponent } from '../../../../@components/custom-smart-table-components/filter-by-number/filter-by-number.component';
import { NgxNumberFieldComponent } from '../../../../@components/custom-smart-table-components/number-field/number-field.component';
import { NgxDateFieldComponent } from '../../../../@components/custom-smart-table-components/date-field/date-field.component';
import { GoalTypeFieldComponent } from '../../../../@components/custom-smart-table-components/goaltype-field/goaltype-field.component';
import { ProgressbarComponent } from '../../../../@components/progressbar/progressbar.component';

/**
 * Component for listing the Goals of a patient
 */
@Component({
    selector: 'app-goal-list',
    templateUrl: './goal-list.component.html',
    styleUrls: ['./goal-list.component.scss'],
})

export class GoalListComponent {
  GoalsListLabel = 'Goals';
  AddPatientLabel = 'Add New';

  CreatedDateLabel = 'Created Date';
  StartDateLabel = 'Start Date';
  TargetDateLabel = 'Target Date';

  GoalTypeLabel = 'Goal Type';
  GoalValueLabel = 'Goal Value';
  ProgressLabel = 'Progress';

  SucessDeleteGoal = 'Sucessfully deleted Goal';
  FailDeleteGoal = 'Problem occurred delelting Goal';
  BackLabel = 'Back';

  GoalsSource: DataSource;
  PatientId: number = null;
  protected readonly unsubscribe$ = new Subject<void >();

    /** GoalList ctor */
  constructor(
    private goalsService: GoalData,
    private router: Router,
    private route: ActivatedRoute,
    private toasterService: NbToastrService,
    ) {
    this.GoalsSource = this.goalsService.gridDataSource;
  }

  /**
   * Settings of the ng2 smart table of Goals
   */
  GoalTableSettings =
  {
    mode: 'external',
    actions:
    {
      position: 'right',
      add: false,
    },
    edit: { editButtonContent: '<img src="assets/icons/added_oultine_modify_pencil.svg" class="img-archive" width="24" height="24">' },
    delete: { deleteButtonContent: '<img src="assets/icons/trash-2-outline.svg" class="img-archive" width="24" height="24">'},
    columns:
    {
      createdDate: {
        title: this.CreatedDateLabel,
        type: 'date',
        filter: {
          type: 'custom',
          component: NgxDateFieldComponent,
        },
      },
      startDate: {
        title: this.StartDateLabel,
        type: 'date',
        filter: {
          type: 'custom',
          component: NgxDateFieldComponent,
        },
      },
      targetDate: {
        title: this.TargetDateLabel,
        type: 'date',
        filter: {
          type: 'custom',
          component: NgxDateFieldComponent,
        },
      },
      goalType: {
        title: this.GoalTypeLabel,
        type: 'string',
        filter: {
          type: 'custom',
          component: GoalTypeFieldComponent,
        },
      },
      goalValue: {
        title: this.GoalValueLabel,
        type: 'string',
        filter: {
          type: 'custom',
          component: NgxNumberFieldComponent,
        },
      },
      customProgress: {
        title: 'Progress',
        type: 'custom',
        filter: false,
        valuePrepareFunction: (cell, row) => {
          return row.progress;
        },
        renderComponent: ProgressbarComponent,
      },
    },
  };

  /**
   * Initializes the component.
   * Gets the Patient ID from the given url and sets the filtering and sorting by that Patient ID.
   */
  ngOnInit(): void {
    this.PatientId = +this.route.snapshot.paramMap.get('PatientId');
    this.GoalsSource.addFilter({ field: 'patientID', search: this.PatientId });
    this.GoalsSource.setSort([{ field: 'targetDate', direction: 'desc' }]);
  }

  /**
   * Navigates to the page for creation of a new Goal for the Patient
   */
  AddGoal() {
    this.router.navigate(['/pages/CalorieFriend/NewGoal/' + this.PatientId]);
  }

  /**
   * Navigates to the page for edition of an existing goal of the Patient
   * @param $event Event object
   */
  onEdit($event) {
    this.router.navigate([`/pages/CalorieFriend/Goal/${$event.data.patientID}/${$event.data.id}`]);
  }

  /**
   * Event handler of the 'Click' event of the 'Delete' action.
   * It deletes a Goal with {id} (given by $event object).
   * @param $event Event object
   */
  onDelete($event) {
    const observable = this.goalsService.delete($event.data.id);

    observable
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.handleGoalDeleteSuccessResponse();
      },
      err => {
        this.handleGoalDeleteWrongResponse();
      },
    );
  }

  /**
   * Handler of Success event of Delete action of an existing item
   */
  handleGoalDeleteSuccessResponse() {
    this.toasterService.success('', this.SucessDeleteGoal);
    // refresh screen
    this.GoalsSource.refresh();
  }

  /**
   * Handler of Fail event of Delete action of an existing item
   */
  handleGoalDeleteWrongResponse() {
    this.toasterService.danger('', this.FailDeleteGoal);
  }

  /**
   * Navigates to the page of the patient
   */
  Back() {
    this.router.navigate([`/pages/CalorieFriend/Patient/` + this.PatientId]);
  }
}
